import axios from "axios";
import { baseURL } from "../utils/constants";
import { header } from "../utils/header";

// Get rooms by hospital ID
export const getRoomsByHospitalId = async (
  hospitalId: string | undefined
) => {
  try {
    const res = await axios.get(
      `${baseURL}/queue/hospital/${hospitalId}/rooms`,
      {
        headers: header(),
      }
    );
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

// Add room mapping
export const addRoomMapping = async (
  roomId: string,
  roomData: {
    room_name: string;
    mappingIds: Array<string>;
  }
) => {
  try {
    const res = await axios.post(
      `${baseURL}/queue/room/${roomId}`,
      roomData,
      {
        headers: header(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

// Update room mapping
export const updateRoomMapping = async (
  roomId: string,
  roomData: {
    room_name: string;
    mappingIds: Array<string>;
  }
) => {
  try {
    const res = await axios.put(
      `${baseURL}/queue/room/${roomId}`,
      roomData,
      {
        headers: header(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

// Remove room mapping
export const removeRoomMapping = async (roomId: string) => {
  try {
    const res = await axios.delete(
      `${baseURL}/queue/room/${roomId}`,
      {
        headers: header(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
}; 


// Get room mapping
export const getRoomMapping = async (mappingId: string) => {
  try {
    const res = await axios.get(
      `${baseURL}/queue/room/mapping/${mappingId}`,
      {
        headers: header(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
}; 